// extracted by mini-css-extract-plugin
module.exports = {"trigger":"accordion_trigger__A7Q0Z","content":"accordion_content__LqYhP"};